var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAtacadaoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162.66,
    height: 50.321,
    viewBox: "0 0 162.66 50.321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.66 1.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M75.187,33.674h1.989l.046-.16.937-3.68-.038.145h-3.1l.145,3.536.008.16Zm38.974-3.307h-4.427l.122-1.615.008-.2.008-.191v-.35l-.008-.16-.008-.145-.015-.137-.015-.122-.015-.114-.022-.1-.023-.091-.023-.076-.022-.061-.023-.046-.008-.015-.038-.069-.023-.03-.015-.015-.022-.015-.039-.015-.069-.023-.1-.015-.137-.008-.175.008-.153.03-.144.046-.137.061-.137.084-.145.114-.144.145-.16.19-.069.091-.083.122-.084.13-.084.145-.083.16-.084.175-.084.183-.076.221-.084.213-.084.229-.083.236-.084.251-.084.259-.083.274-.084.29-.076.3-.076.312-.069.3-.061.282-.053.267-.045.259-.038.244-.031.229-.023.213-.015.2-.008.183v.312l.008.13.015.114.015.091.008.046.038.107.023.046.008.015.008.008.023.015.061.023.122.023.183.008.183-.008.175-.023.175-.046.175-.061.176-.084.183-.107.183-.13.2-.16.083-.076.092-.091.091-.1.084-.1.084-.107.083-.107.076-.114.076-.122.076-.13.069-.13.068-.137.069-.145.061-.145.061-.152.061-.16.351-1.074h4.267ZM84.582,33.674h1.493l.008-.008.015-.008.023-.015.03-.023.046-.038.053-.061.061-.076.069-.091.076-.107.084-.122.091-.145L88.376,30H84.917l-.937,3.688h.6Zm51.1-2.636.076-.251.076-.267.076-.274.076-.29.069-.29.061-.274.053-.267.045-.251.045-.236.039-.221.03-.206.023-.2.015-.183.008-.16v-.145l-.008-.13-.008-.114-.008-.1-.015-.069-.008-.03L136.3,27l-.008-.023-.023-.015-.069-.023-.122-.023-.144-.008-1.661,6.515.061-.038.13-.1.137-.122L134.75,33l.061-.076.076-.107.076-.122.076-.13.076-.145.083-.16.084-.175.084-.191.083-.2.084-.213.084-.229ZM162.073,27.5l-.084.137-.083.145-.084.16-.084.175-.083.19-.084.2-.084.213-.083.229-.084.236-.084.251-.083.267-.084.274-.076.29-.076.3-.076.3-.069.29-.061.282-.054.267-.045.251-.038.244-.031.229-.022.213-.015.2-.015.183-.008.168v.152l.008.13.008.114.015.1.008.053.038.114.023.046.015.008.069.015.13.008.153-.008.137-.023.13-.038.122-.061.13-.084.136-.107.137-.145.153-.191.069-.091.076-.122.084-.137.084-.145.083-.16.084-.175.084-.191.083-.2.084-.213.084-.229.083-.236.084-.251.084-.267.083-.274.076-.29.076-.3.076-.3.069-.29.061-.282.053-.267.045-.251.039-.236.03-.229.023-.213.015-.2.008-.183.008-.168V27.22l-.008-.137-.008-.114-.015-.1-.008-.053-.039-.122-.022-.046h-.008l-.069-.015-.13-.008-.153.008-.136.023-.13.038-.122.061-.13.084-.137.107-.145.145-.16.19-.069.091Zm-7.925.739.175-.4.191-.4.206-.381.221-.373.236-.358.251-.35.267-.335.281-.32.3-.312.312-.3.32-.282.336-.274.35-.259.359-.244.366-.229.373-.206.389-.191.4-.175.4-.16.411-.137.42-.122.427-.107.434-.091.434-.076.442-.053.45-.038.457-.023.465-.008.457.008.45.023.434.038.427.061.411.076.4.091.389.114.381.13.366.152.35.175.336.19.32.213.3.236.289.259.267.274.244.3.228.312.206.328.183.343.153.35.13.366.106.373.084.381.061.389.038.4.015.4-.008.412-.031.419-.045.427-.069.434-.083.442-.107.45-.122.442-.137.434-.152.427-.167.411-.184.4-.19.4-.206.381-.221.373-.236.358-.251.35-.267.335-.281.32-.3.312-.312.3-.32.282-.328.274-.351.259-.358.244-.358.213-.373.206-.389.191-.4.175-.4.16-.412.137-.419.122-.427.107-.434.091-.442.076-.45.053-.45.038-.457.023-.464.008-.457-.008-.45-.023-.434-.038-.427-.061-.411-.076-.4-.091-.389-.114-.381-.13-.366-.152-.35-.175-.336-.191-.32-.213-.061-.046-.236.937H138.072l.258-1.029-.381.168-.4.152-.4.137-.419.122-.427.107-.434.091-.45.076-.457.061-.464.046-.473.038-.487.023-.487.008H109.46l.083-.335-.183.091-.32.137-.327.122-.336.114-.343.1-.35.084-.358.069-.366.061-.366.046-.373.03-.381.015-.388.008-.434-.023-.434-.023-.42-.038-.411-.061-.4-.076-.389-.091-.373-.114-.366-.13-.35-.152-.336-.175-.32-.191-.3-.213-.114-.091-.214.831H58.873l1.135-4.45H61.5l.008-.008.023-.015.023-.015.03-.023.038-.038.053-.061.061-.076.069-.091.076-.107.084-.122.091-.145,6.164-10.53h6.492l.114,2.857.731-2.857H91.333l-1.128,4.419L92.8,22.443h6.492l.275,6.728.114-.32.16-.4.175-.4.183-.389.2-.373.214-.366.228-.358.244-.343.251-.335.267-.32.282-.312.289-.3.3-.29.32-.274.328-.267.335-.244.343-.229.35-.213.359-.2.366-.183.373-.168.381-.145.389-.13.4-.114.4-.091.4-.076.412-.061.419-.046.42-.023.419-.008.289.008.282.015.274.023.275.03.267.038.267.046.258.053.251.061.251.076.251.084.244.091.229-.328h4.366l-1.874,7.368L118.8,22.45h6.491l.457,11.079.008.16h1.623l.015-.061.022-.084,1.692-6.652H127.48l1.128-4.442h7.78l.488.008.48.023.465.038.449.046.434.061.42.076.4.091.389.114.381.13.366.145.351.168.335.191.312.206.3.229.281.251.259.274.228.29.206.312.183.328.153.343.13.35.106.366.076.373.053.381.03.389.008.4-.008.4-.03.411-.008.061,2.979-5.1h-.571l2.164-3.795h7.559l-1.829,3.208Z",
    transform: "translate(-9.851 -3.468)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M179.128,25.878a2.6,2.6,0,0,0-2.134,1.166,11.116,11.116,0,0,0-1.532,3.749,9.157,9.157,0,0,0-.4,3.81,1.409,1.409,0,0,0,1.523,1.173,2.579,2.579,0,0,0,2.134-1.166,11.117,11.117,0,0,0,1.524-3.756,9.035,9.035,0,0,0,.4-3.795,1.378,1.378,0,0,0-1.509-1.181m-8.489,4.953a9.025,9.025,0,0,1,3.223-5.105,9.156,9.156,0,0,1,5.783-1.852c2.248,0,3.847.617,4.815,1.852s1.173,2.934.617,5.105a8.985,8.985,0,0,1-3.216,5.09,9.19,9.19,0,0,1-5.783,1.836q-3.361,0-4.809-1.851C170.3,34.686,170.091,32.987,170.64,30.831Z",
    transform: "translate(-25.656 -4.019)",
    fill: "#093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M162.062,31.349l-.122-3.962-2.073,3.962Zm-2.019,6.1.473-1.859h.556a2.559,2.559,0,0,0,.884-.084.426.426,0,0,0,.236-.312,2.092,2.092,0,0,0,.053-.29,1.562,1.562,0,0,0,.008-.267l-.092-1.4h-3.352l-.709,1.25a4.162,4.162,0,0,0-.244.45,1.494,1.494,0,0,0-.114.3c-.031.114.023.2.16.267a1.6,1.6,0,0,0,.618.091h.617l-.473,1.859H153.1l.472-1.859h.457a1.433,1.433,0,0,0,.876-.312,3.56,3.56,0,0,0,.815-1.029l5.791-9.89h4.5l.4,9.852a2.328,2.328,0,0,0,.244,1.181,1.008,1.008,0,0,0,.739.206h.655l-.472,1.859h-7.544Z",
    transform: "translate(-23.212 -4.087)",
    fill: "#093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M147.525,24.344q3.738,0,5.129,1.608t.548,4.93a8.359,8.359,0,0,1-3.071,4.938,9.918,9.918,0,0,1-5.943,1.615h-6.767l.473-1.859h.625a1.676,1.676,0,0,0,.846-.152,1.576,1.576,0,0,0,.419-.876l.022-.1,1.821-7.147c.13-.51.145-.823.054-.937s-.351-.175-.8-.175h-.609l.473-1.852h6.781ZM143.7,35.522h.976a2.719,2.719,0,0,0,2.21-1.067,9.72,9.72,0,0,0,1.493-3.574,7.711,7.711,0,0,0,.328-3.581,1.529,1.529,0,0,0-1.669-1.067h-.975Z",
    transform: "translate(-20.793 -4.084)",
    fill: "#093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M98.4,31.349l-.122-3.962-2.072,3.962Zm-2.019,6.1.472-1.859h.556A2.558,2.558,0,0,0,98.3,35.5a.426.426,0,0,0,.236-.312,2.094,2.094,0,0,0,.053-.29,1.562,1.562,0,0,0,.008-.267l-.091-1.4H95.149l-.709,1.25a4.19,4.19,0,0,0-.244.45,1.469,1.469,0,0,0-.114.3c-.03.114.023.2.16.267a1.592,1.592,0,0,0,.617.091h.617L95,37.444H89.442l.472-1.859h.457a1.434,1.434,0,0,0,.876-.312,3.575,3.575,0,0,0,.815-1.029l5.791-9.89h4.5l.4,9.852a2.328,2.328,0,0,0,.244,1.181,1.008,1.008,0,0,0,.739.206h.656l-.473,1.859H96.384Z",
    transform: "translate(-13.704 -4.087)",
    fill: "#093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M119.515,32.471a7.039,7.039,0,0,1-7.238,5.463q-3.223,0-4.5-1.8c-.853-1.2-.99-2.911-.427-5.136a9.346,9.346,0,0,1,3.086-5.052,8.033,8.033,0,0,1,5.288-1.9,7.064,7.064,0,0,1,1.821.221,4.751,4.751,0,0,1,1.486.693l.5-.724h2.019l-1.371,5.395h-2.233a5.268,5.268,0,0,0-.3-2.743,1.639,1.639,0,0,0-1.585-.853,2.69,2.69,0,0,0-2.209,1.166,10.765,10.765,0,0,0-1.555,3.749,8.627,8.627,0,0,0-.366,3.84,1.561,1.561,0,0,0,1.707,1.173,3.371,3.371,0,0,0,2.309-.945,5.6,5.6,0,0,0,1.554-2.56h2.012Z",
    transform: "translate(-16.295 -4.045)",
    fill: "#093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    d: "M128.714,31.349l-.122-3.962-2.073,3.962Zm-2.019,6.1.472-1.859h.556a2.556,2.556,0,0,0,.884-.084.426.426,0,0,0,.236-.312,1.97,1.97,0,0,0,.053-.29,1.561,1.561,0,0,0,.008-.267l-.091-1.4H125.46l-.708,1.25a4.205,4.205,0,0,0-.245.45,1.5,1.5,0,0,0-.114.3c-.03.114.023.2.16.267a1.591,1.591,0,0,0,.617.091h.617l-.472,1.859h-5.563l.473-1.859h.457a1.433,1.433,0,0,0,.876-.312,3.56,3.56,0,0,0,.815-1.029l5.791-9.89h4.5l.4,9.852a2.328,2.328,0,0,0,.244,1.181,1.008,1.008,0,0,0,.739.206h.656l-.473,1.859H126.7Z",
    transform: "translate(-18.179 -4.087)",
    fill: "#093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M82.7,26.395a2.4,2.4,0,0,0-1.753.731,4.521,4.521,0,0,0-1.082,2.118l-.015.053H78.015l1.265-4.953h13.1L91.114,29.3H89.292l.015-.053a3.177,3.177,0,0,0-.008-2.118,1.408,1.408,0,0,0-1.394-.739h-.541l-2.05,8.062q-.194.754-.046.937t.8.183h1.044l-.472,1.859h-8.2l.472-1.859h.968a1.776,1.776,0,0,0,.869-.152,1.78,1.78,0,0,0,.442-.968l2.05-8.062H82.7Z",
    transform: "translate(-12.015 -4.085)",
    fill: "#093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    d: "M69.772,31.349l-.122-3.962-2.072,3.962Zm-2.019,6.1.472-1.859h.556a2.558,2.558,0,0,0,.884-.084.427.427,0,0,0,.236-.312,2.118,2.118,0,0,0,.053-.29,1.587,1.587,0,0,0,.008-.267l-.091-1.4H66.534l-.709,1.25a4.2,4.2,0,0,0-.244.45,1.475,1.475,0,0,0-.114.3c-.03.114.023.2.16.267a1.593,1.593,0,0,0,.617.091h.617l-.472,1.859H60.827l.472-1.859h.457a1.434,1.434,0,0,0,.876-.312,3.572,3.572,0,0,0,.815-1.029l5.791-9.89h4.5l.4,9.852a2.332,2.332,0,0,0,.244,1.181,1.008,1.008,0,0,0,.739.206h.655l-.472,1.859H67.753Z",
    transform: "translate(-9.479 -4.087)",
    fill: "#093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M163.74,21.521h4.572l-.686,1.2h-4.572Z",
    transform: "translate(-24.623 -3.64)",
    fill: "#093",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M39.073,39.243V42.3c-.229,3.193-2.179,3.581-5.113,3.764v7.223H53.619V46.078c-2.934-.191-4.9-.564-5.12-3.772V39.258Z",
    transform: "translate(-5.52 -6.286)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 3.321,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M39.073,39.243V42.3c-.229,3.193-2.179,3.581-5.113,3.764v7.223H53.619V46.078c-2.934-.191-4.9-.564-5.12-3.772V39.258Z",
    transform: "translate(-5.52 -6.286)",
    fill: "#f63",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M1.1,27.861H49.039a.558.558,0,0,1,.518.594v.008a.563.563,0,0,1-.518.594H1.1a.558.558,0,0,1-.518-.594v-.008A.563.563,0,0,1,1.1,27.861Z",
    transform: "translate(-0.586 -4.565)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 3.32,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    d: "M1.1,27.861H49.039a.558.558,0,0,1,.518.594v.008a.563.563,0,0,1-.518.594H1.1a.558.558,0,0,1-.518-.594v-.008a.563.563,0,0,1,.518-.594",
    transform: "translate(-0.586 -4.565)",
    fill: "#299341",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    "data-name": "Path",
    d: "M1.1,31.341H49.039a.558.558,0,0,1,.518.594v.008a.563.563,0,0,1-.518.594H1.1a.558.558,0,0,1-.518-.594v-.008A.563.563,0,0,1,1.1,31.341Z",
    transform: "translate(-0.586 -5.072)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 3.32,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-9",
    "data-name": "Path",
    d: "M1.1,31.341H49.039a.558.558,0,0,1,.518.594v.008a.563.563,0,0,1-.518.594H1.1a.558.558,0,0,1-.518-.594v-.008a.563.563,0,0,1,.518-.594",
    transform: "translate(-0.586 -5.072)",
    fill: "#299341",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    "data-name": "Path",
    d: "M1.1,34.821H49.039a.558.558,0,0,1,.518.594v.008a.563.563,0,0,1-.518.594H1.1a.558.558,0,0,1-.518-.594v-.008A.563.563,0,0,1,1.1,34.821Z",
    transform: "translate(-0.586 -5.58)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 3.32,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-11",
    "data-name": "Path",
    d: "M1.1,34.821H49.039a.558.558,0,0,1,.518.594v.008a.563.563,0,0,1-.518.594H1.1a.558.558,0,0,1-.518-.594v-.008a.563.563,0,0,1,.518-.594",
    transform: "translate(-0.586 -5.58)",
    fill: "#299341",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-12",
    "data-name": "Path",
    d: "M1.1,38.231H49.039a.558.558,0,0,1,.518.594v.008a.563.563,0,0,1-.518.594H1.1a.558.558,0,0,1-.518-.594v-.008A.563.563,0,0,1,1.1,38.231Z",
    transform: "translate(-0.586 -6.077)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 3.32,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-13",
    "data-name": "Path",
    d: "M1.1,38.231H49.039a.558.558,0,0,1,.518.594v.008a.563.563,0,0,1-.518.594H1.1a.558.558,0,0,1-.518-.594v-.008a.563.563,0,0,1,.518-.594",
    transform: "translate(-0.586 -6.077)",
    fill: "#299341",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-14",
    "data-name": "Path",
    d: "M1.1,24.38H49.039a.558.558,0,0,1,.518.594v.008a.563.563,0,0,1-.518.594H1.1a.558.558,0,0,1-.518-.594v-.008A.563.563,0,0,1,1.1,24.38Z",
    transform: "translate(-0.586 -4.057)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 3.32,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-15",
    "data-name": "Path",
    d: "M1.1,24.38H49.039a.558.558,0,0,1,.518.594v.008a.563.563,0,0,1-.518.594H1.1a.558.558,0,0,1-.518-.594v-.008A.563.563,0,0,1,1.1,24.38",
    transform: "translate(-0.586 -4.057)",
    fill: "#299341",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-16",
    "data-name": "Path",
    d: "M1.5,40.426v7.16H21.311l-.03-7.16c-1.4,0-2.316-.114-2.941-.667-.648-.546-.617-1.214.084-2.313L34.463,12.8v8.168h9.38V.586H32.527L9.478,35.83C7.078,39.531,6.27,40.51,1.5,40.426Z",
    transform: "translate(-0.716 -0.586)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 3.321,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-17",
    "data-name": "Path",
    d: "M1.5,40.426v7.16H21.311l-.03-7.16c-1.4,0-2.316-.114-2.941-.667-.648-.546-.617-1.214.084-2.306L34.463,12.8v8.168h9.38V.586H32.527L9.478,35.83c-2.4,3.7-3.208,4.679-7.978,4.6",
    transform: "translate(-0.716 -0.586)",
    fill: "#f63",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-18",
    "data-name": "Path",
    d: "M23.449,21.5l10-.084-3.718,5.738-9.829-.206Z",
    transform: "translate(-3.325 -3.634)",
    fill: "#f63",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 13.273,
    height: 1.196,
    transform: "translate(31.749 20.324)",
    fill: "#4b9a5d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtacadaoLogo);
export default __webpack_public_path__ + "static/media/atacadao-logo.5f795904a0cfc525f0a833faf2467356.svg";
export { ForwardRef as ReactComponent };